import React from "react";
import Breadcrumbs from "../../reusebale/breadcrumbs"
import ProfileInfo from "./profileInfo"
import { useSelector } from "react-redux"
const ViewProfile = ({ onBack, onTriggerCard }) => {
  const { loader, loginSuccess, loginError } = useSelector(
    (state) => state.auth
  );
  return (
    <div className="mt-5">
      <Breadcrumbs
        classes={`text-darkColor font-popinsSemiBold text-xl`}
        subheading="My Account"
        content={`${loginSuccess?.user?.firstName} ${loginSuccess?.user?.lastName}`}
        onBack={onBack}
      />
      <ProfileInfo onAction={onTriggerCard}/>
    </div>
  );
};

export default ViewProfile;
